var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"companies"},[_c('SectionHeader',{scopedSlots:_vm._u([{key:"breadcrumbs",fn:function(){return [_c('BreadCrumbs',{attrs:{"items":[
          { text: _vm.$t('meta.sites'), name: 'company_sites' },
          {
            text: _vm.site && _vm.site.name,
            name: 'site',
            params: {
              uuid: _vm.$route.params.uuid,
              site_uuid: _vm.$route.params.site_uuid,
            },
          },
          { text: _vm.$t('areas.createArea') } ]}})]},proxy:true}])}),_c('div',{staticClass:"body-content"},[_c('CompanyNav'),_c('div',{staticClass:"body"},[(_vm.loading)?_c('LoadingSpinner'):_c('AreaForm',{attrs:{"site":_vm.site},on:{"submit":_vm.createArea}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }